module.exports = __webpack_public_path__ + "img/Fork_bomb.10bdcf0a.svg";